// Backwards-compatible shim. v3 onwards the SPA stores a session
// token, not an API key. AuthModal still calls into here, but
// `apiKey` returned now means "session token". Kept under the same
// hook name to minimise churn for components that just want the
// "logged-in?" boolean.
import { useCallback, useEffect, useState } from "react";
import {
  clearSession,
  readStoredSession,
  saveSession,
} from "@/lib/storage";

export function useApiKey() {
  const [apiKey, setApiKey] = useState<string>("");

  useEffect(() => {
    setApiKey(readStoredSession());
  }, []);

  const save = useCallback((token: string, remember: boolean) => {
    saveSession(token, remember);
    setApiKey(token);
  }, []);

  const clear = useCallback(() => {
    clearSession();
    setApiKey("");
  }, []);

  return { apiKey, save, clear };
}
